import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0fd60cd4&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=0fd60cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd60cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd60cd4')) {
      api.createRecord('0fd60cd4', component.options)
    } else {
      api.reload('0fd60cd4', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=0fd60cd4&scoped=true&", function () {
      api.rerender('0fd60cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/create.vue"
export default component.exports